import { bugsnagClient } from 'helpers/bugsnagHelper';

export default function applyGoogleTranslateDOMPatch() {
  // Guard for SSR / non-browser environments
  if (typeof Node !== 'function' || !Node.prototype) return;

  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  // Patch removeChild
  try {
    (Node.prototype.removeChild as any) = function safeRemoveChild<
      T extends Node,
    >(this: Node, child: T): T {
      // Ignore bad Google Translate DOM ops
      if (child?.parentNode !== this) {
        return child;
      }

      // Valid path
      return originalRemoveChild.call(this, child) as T;
    };
  } catch (err) {
    const diagnostics = {
      op: 'removeChildPatchFailure',
      error: String(err),
      nodeHasPrototype: Boolean(Node?.prototype),
    };

    bugsnagClient.notify(
      new Error('googleTranslateDOMPatch.removeChild.patchFailure'),
      (event: any) => {
        Object.assign(event, {
          context: 'applyGoogleTranslateDOMPatch',
          severity: 'error',
        });

        event.addMetadata('diagnostics', diagnostics);
      }
    );
  }

  // Patch insertBefore
  try {
    (Node.prototype.insertBefore as any) = function safeInsertBefore<
      T extends Node,
    >(this: Node, newNode: T, referenceNode: Node | null): T {
      // Ignore invalid insertBefore attempts
      if (referenceNode && referenceNode.parentNode !== this) {
        return newNode;
      }

      // Valid path
      return originalInsertBefore.call(this, newNode, referenceNode) as T;
    };
  } catch (err) {
    const diagnostics = {
      op: 'insertBeforePatchFailure',
      error: String(err),
      nodeHasPrototype: Boolean(Node?.prototype),
    };

    bugsnagClient.notify(
      new Error('googleTranslateDOMPatch.insertBefore.patchFailure'),
      (event: any) => {
        Object.assign(event, {
          context: 'applyGoogleTranslateDOMPatch',
          severity: 'error',
        });

        event.addMetadata('diagnostics', diagnostics);
      }
    );
  }
}
